import store from '@/store'
import brandsConfig from '../configs/brands.json'
import { getLoginUrl, getToken } from './auth';
const {VUE_APP_ENVIROMENT} = process.env;


const responseHandler = async response => {
  if (response.status === 401) {
    window.location.href = getLoginUrl(window.location.origin, process.env.VUE_APP_SSO_CLIENT_ID);
    throw new Error('HTTP 401 Unauthorized');
  }
  
  const jsonResponse = await response.json();
  
  // Check for GraphQL authentication errors
  if (jsonResponse.errors && Array.isArray(jsonResponse.errors)) {
    const hasUnauthenticatedError = jsonResponse.errors.some(error => 
      error.extensions && error.extensions.code === 'UNAUTHENTICATED'
    );
    
    if (hasUnauthenticatedError) {
      window.location.href = getLoginUrl(window.location.origin, process.env.VUE_APP_SSO_CLIENT_ID);
      throw new Error('HTTP 401 Unauthorized');
    }
  }
  
  return jsonResponse;
}


const getSearchIndice = () => {

  if(!store.getters.getActiveBrand) {
    console.log('[DEBUG]: INDICE NOT DEFINED')
    return null
  }
  const brandConfig = brandsConfig[store.getters.getActiveBrand][VUE_APP_ENVIROMENT]
  return brandConfig.indice
}

const getSearchMarque = () => {
  if(!store.getters.getActiveBrand) {
    console.log('[DEBUG]: BRAND NOT DEFINED')
    return null
  }
  const brandConfig = brandsConfig[store.getters.getActiveBrand][VUE_APP_ENVIROMENT]
  return brandConfig.allowedMarque
}

const makeFetchRequest = async (path, method = 'GET', body = {}) => {
  const contextInfo = store.state.contextInfo;

  const params = {
    method: method,
    headers: {
      'content-Type': 'application/json',
      'context': `${contextInfo.partner}-${contextInfo.sales_type}-${contextInfo.allotement}`,
      'marque': getSearchMarque(),
      'does-brand-need-context': store.getters.getActiveBrand === 'ucpa',
      "authorization" : `Bearer ${getToken()}`,
      'indice': getSearchIndice(),
      'apollographql-client-name': `call-center-${store.getters.getActiveBrand}-dashboard`,
      'organization': "WEBTALES",
      'application': "UCPA CALL CENTER"
    },
    body: Object.keys(body).length !== 0 ? JSON.stringify(body) : undefined,
  };

  // console.log('[REQUEST]: ', path);

  return fetch(path, params).then(responseHandler)
    .then(response => ({success: true, data: response}))
    .catch(err => ({success: false, data: err}))
}



export { makeFetchRequest };